const conditions = () => {
  return [
    { projectType: { $ne: '' } },
    {
      assetClass: {
        $in: {
          'object.asset-class.options.wohnen': 'object.special-rights.wohnen.options',
          'object.asset-class.options.handel-retail': 'object.special-rights.wohnen.options',
          'object.asset-class.options.hotel': 'object.special-rights.wohnen.options',
          'object.asset-class.options.healthcare-medical': 'object.special-rights.wohnen.options',
          'object.asset-class.options.buero': 'object.special-rights.wohnen.options',
          'object.asset-class.options.micro-und-serviced-living': 'object.special-rights.wohnen.options',
          'object.asset-class.options.freies-ankaufsprofil': 'object.special-rights.wohnen.options',
          'object.asset-class.options.logistik-industrie': 'object.special-rights.wohnen.options',
        },
      },
    },
  ]
}

export default conditions
